var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"font-weight-bold animate",attrs:{"dark":_vm.dark,"flat":""},on:{"click":_vm.switchLocales}},[_c('span',{staticClass:"mx-2"},[_vm._v(_vm._s(_vm.availableLocale))]),_c('v-icon',[_vm._v("language")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }